import React from 'react';
import { Components } from './styled';
import { SMALL_PROJECT_MODAL_WIDTH } from '../../../utils/styled/dimensions';
import ProjectSimpleModal from '../../ProjectSimpleModal';

const ModalBody = ({
  confirmationText,
  modalTitle,
  onConfirm,
  onCancel,
  detailsText,
}: {
  confirmationText?: string;
  modalTitle?: string;
  onConfirm: () => void;
  onCancel: () => void;
  detailsText?: string;
}) => {
  return (
    <Components.ModalContainer>
      <Components.ModalBodyContainer>
        <Components.ModalTitle>{modalTitle ? modalTitle : 'Confirmation'}</Components.ModalTitle>
        <Components.ModalContentWrapper>
          <Components.ModalQuestion>{confirmationText}</Components.ModalQuestion>
          {detailsText && <Components.Subtitle>{detailsText}</Components.Subtitle>}
        </Components.ModalContentWrapper>
      </Components.ModalBodyContainer>
      <Components.ModalButtonsContainer>
        <Components.ModalTertiaryButton onClick={onCancel}>Cancel</Components.ModalTertiaryButton>
        <Components.ModalPrimaryButton onClick={onConfirm}>Confirm</Components.ModalPrimaryButton>
      </Components.ModalButtonsContainer>
    </Components.ModalContainer>
  );
};

const ConfirmationModal = ({
  isModalOpen,
  onModalClose,
  onConfirm,
  modalState,
  modalTitle,
  confirmationText,
  detailsText,
}: {
  isModalOpen: boolean;
  onModalClose?: () => void;
  onConfirm?: (modalState?: any) => void;
  modalState?: any;
  modalTitle?: string;
  confirmationText: ((extraData: any) => string) | string;
  detailsText?: ((extraData: any) => string) | string;
}) => {
  const _onConfirm = () => {
    onConfirm?.(modalState);
    onModalClose?.();
  };
  const _onCancel = () => {
    onModalClose?.();
  };

  const text = typeof confirmationText === 'function' ? confirmationText(modalState) : confirmationText;
  const smallText = typeof detailsText === 'function' ? detailsText(modalState) : detailsText;

  return (
    <ProjectSimpleModal
      bodyChildren={
        <ModalBody
          confirmationText={text}
          modalTitle={modalTitle}
          onConfirm={_onConfirm}
          onCancel={_onCancel}
          detailsText={smallText}
        />
      }
      isModalOpen={isModalOpen}
      modalWidth={SMALL_PROJECT_MODAL_WIDTH}
      disableCloseOnClickAway
    />
  );
};

export default ConfirmationModal;
